var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { Container, Flex, Hide, getPaletteColor } from 'pcln-design-system';
import CalendarCard from '../CalendarCard';
import Month from '../Month';
import Footer from '../Footer';
import useCalendar from '../useCalendar';
var LeftAlignedContainer = /*#__PURE__*/styled(Container).withConfig({
  displayName: "CalendarRoot__LeftAlignedContainer",
  componentId: "sc-fgjcji-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  &&& {\n    margin-left: unset;\n    margin-right: unset;\n    z-index: 4;\n\n    ", " {\n      width: auto;\n    }\n  }\n"], ["\n  ", "\n  &&& {\n    margin-left: unset;\n    margin-right: unset;\n    z-index: 4;\n\n    ", " {\n      width: auto;\n    }\n  }\n"])), function (props) {
  return props.isFixedPositionedCalendar && 'position: fixed;';
}, function (props) {
  return props.theme.mediaQueries[1];
});
var CalendarFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "CalendarRoot__CalendarFlex",
  componentId: "sc-fgjcji-1"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &&& {\n    position: relative;\n    z-index: 4;\n    ", " {\n      ", "\n    }\n    ", ";\n  }\n"], ["\n  &&& {\n    position: relative;\n    z-index: 4;\n    ", " {\n      ", "\n    }\n    ", ";\n  }\n"
/** @public */])), function (props) {
  return props.theme.mediaQueries[1];
}, function (props) {
  return !props.isMobile && "\n        box-shadow: ".concat(props.hasBoxShadow ? props.theme.shadows['overlay-lg'] : 'none', ";\n      ");
}, function (props) {
  return !props.isMobile ? "background-color: ".concat(getPaletteColor('background.lightest')(props)) : '';
});
/** @public */
function CalendarRoot(_a) {
  var className = _a.className;
  var _b = useCalendar(),
    animateScroll = _b.animateScroll,
    boxShadow = _b.boxShadow,
    calendarRef = _b.calendarRef,
    calendarWrapperStyles = _b.calendarWrapperStyles,
    dayGap = _b.dayGap,
    dayWrapperStyleOverride = _b.dayWrapperStyleOverride,
    dayWithRoundedCorners = _b.dayWithRoundedCorners,
    didUseKeyNavigation = _b.didUseKeyNavigation,
    displayYear = _b.displayYear,
    endDate = _b.endDate,
    firstValidMonth = _b.firstValidMonth,
    footer = _b.footer,
    highlightedDates = _b.highlightedDates,
    hoveredDate = _b.hoveredDate,
    isFixedPositionedCalendar = _b.isFixedPositionedCalendar,
    isMobile = _b.isMobile,
    locale = _b.locale,
    maxDate = _b.maxDate,
    maxSelectableDate = _b.maxSelectableDate,
    minDate = _b.minDate,
    monthIndex = _b.monthIndex,
    months = _b.months,
    monthsToShow = _b.monthsToShow,
    monthWidth = _b.monthWidth,
    _c = _b.roundedCorners,
    roundedCorners = _c === void 0 ? true : _c,
    scrollToMonth = _b.scrollToMonth,
    selectTwoDates = _b.selectTwoDates,
    _d = _b.showHoveredDates,
    showHoveredDates = _d === void 0 ? typeof window !== 'undefined' && window.innerWidth > 640 : _d,
    startDate = _b.startDate,
    useDefaultFooter = _b.useDefaultFooter,
    use2024DesignSeti = _b.use2024DesignSeti,
    handleKeyNav = _b.handleKeyNav,
    onDayClicked = _b.onDayClicked,
    onDayHovered = _b.onDayHovered,
    onDismiss = _b.onDismiss,
    onDisplayMonthsChange = _b.onDisplayMonthsChange,
    setSelectedDayRef = _b.setSelectedDayRef;
  var isTouch = document ? 'ontouchstart' in document.documentElement : true;
  var hasFooterBoxShadow = boxShadow && footer || useDefaultFooter ? boxShadow : null;
  return React.createElement(LeftAlignedContainer, {
    className: className,
    height: isMobile ? '100%' : 'auto',
    maxWidth: !isMobile && monthWidth * monthsToShow,
    "data-testid": 'calendar-root',
    isFixedPositionedCalendar: isFixedPositionedCalendar
  }, React.createElement(CalendarFlex, {
    borderRadius: roundedCorners ? '2xl' : undefined,
    flexDirection: 'column-reverse',
    hasBoxShadow: hasFooterBoxShadow,
    isMobile: isMobile,
    height: isMobile ? '100%' : 'auto'
  }, !isMobile && React.createElement(Hide, {
    xs: true,
    sm: true
  }, React.createElement(Flex, {
    width: monthsToShow * monthWidth
  }, footer && !useDefaultFooter && React.cloneElement(footer, {
    dismissCalendar: onDismiss || undefined,
    roundedCorners: roundedCorners || undefined
  }), useDefaultFooter && React.createElement(Footer, {
    roundedCorners: roundedCorners,
    use2024DesignSeti: use2024DesignSeti,
    dismissCalendar: onDismiss
  }))), React.createElement(CalendarCard, {
    animateScroll: animateScroll,
    boxShadow: boxShadow && !footer && !useDefaultFooter ? boxShadow : null,
    calendarWrapperStyles: calendarWrapperStyles,
    firstValidMonth: firstValidMonth,
    hoveredDate: hoveredDate,
    isMobile: isMobile,
    maxSelectableDate: maxSelectableDate,
    monthsToShow: monthsToShow,
    monthWidth: monthWidth,
    roundedCorners: !isMobile && roundedCorners,
    scrollToMonth: scrollToMonth,
    useDefaultFooter: useDefaultFooter,
    keyNavHandler: handleKeyNav,
    onDisplayMonthsChange: onDisplayMonthsChange,
    onDismiss: onDismiss,
    setCalendarRef: calendarRef
  }, months.map(function (month, i) {
    return React.createElement(Month, __assign({}, month, {
      currentMonthIndex: monthIndex,
      dayGap: dayGap,
      dayWrapperStyleOverride: dayWrapperStyleOverride,
      dayWithRoundedCorners: dayWithRoundedCorners,
      didUseKeyNavigation: didUseKeyNavigation,
      displayYear: displayYear,
      endDate: endDate,
      hoveredDate: hoveredDate,
      highlightedDates: highlightedDates,
      index: i,
      isMobile: isMobile,
      isTouch: isTouch,
      key: i,
      locale: locale,
      maxDate: maxDate,
      maxSelectableDate: maxSelectableDate,
      minDate: minDate,
      monthsToShow: monthsToShow,
      monthWidth: monthWidth,
      showHoveredDates: selectTwoDates || showHoveredDates,
      startDate: startDate,
      use2024DesignSeti: use2024DesignSeti,
      onDayClicked: onDayClicked,
      onDayHovered: onDayHovered,
      setSelectedDayRef: setSelectedDayRef
    }));
  }))));
}
export default CalendarRoot;
var templateObject_1, templateObject_2;